// extracted by mini-css-extract-plugin
export var header = "_fm-0";